// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.15 13.5C2.24 13.5 1.5 12.76 1.5 11.85V4.25C1.5 3.15 2.4 2.25 3.5 2.25H5.15C5.65 2.25 6.08 2.48 6.4 2.86L6.88 3.43C7.2 3.81 7.63 4.05 8.13 4.05H11.45C12.42 4.05 13.2 4.83 13.2 5.8V6.65',
  'M3.15 13.5H11.45C12.39 13.5 13.04 12.98 13.29 12.07L14.35 8.15C14.61 7.2 14.06 6.51 13.2 6.65C10.86 7.04 8.61 7.04 6.3 6.65C5.48 6.51 4.82 6.89 4.52 7.64L2.82 11.91C2.45 12.83 2.44 13.5 3.15 13.5Z',
];
